<footer style="margin-top: 40px">
  <div class="container-fluid footer__navigation">
    <div #zoneNgContent
      class="container">
      <ng-content></ng-content>
    </div>
  </div>

  <div class="container-fluid footer__piv"
    role="contentinfo">
    <div class="container">
      <div class="col-12 d-flex flex-column align-items-center justify-content-center"
        lang="fr">
        <a href="/conditions-utilisation">{{'footer.conditions' | translate}}</a>
        <a href="https://mrnf.gouv.qc.ca"
          target="_blank">
          <div aria-label="Ministère des Ressources naturelles et des Forêts"
            role="link">
            <svg-logo-mrnf></svg-logo-mrnf>
          </div>
        </a>
        <div class="col-12 d-flex align-items-center justify-content-center liens">
          <a href="{{'footer.url-gov' | translate}}"
            target="_blank">
            {{'footer.gov' | translate}}&nbsp;{{annee_copyright}}&nbsp;
            <svg-lien-externe></svg-lien-externe>
          </a>
        </div>
      </div>

    </div>
  </div>
</footer>